





































































































import { defineComponent, reactive, toRefs, onMounted, watch } from '@vue/composition-api';
import * as ExcelJS from 'exceljs';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import moment from 'moment';
import AlertArea from "../../components/AlertArea.vue";
import { SumupListCondition, SumupGroup } from "../../modules/teacher/SumupList"
import { create, head } from 'lodash';


export interface Data {
  condition: SumupListCondition
  sumupGroups: SumupGroup[]
  fields: any[]
  totalCount: number
  isAllCheckedDelete: boolean
  errors: string[]
  isShow: boolean
  progressFloat: number
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){
    
    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      condition: context.root.$store.state.sumupListCondition,
      sumupGroups: new Array<SumupGroup>(),
      fields: [
        {key: "id", label: "集計ID", sortable: true, class: 'text-center b-table-th-td'},
        {key: "exec_date", label: "実施日", sortable: true, class: 'text-center b-table-th-td'},
        {key: "name", label: "試験名", sortable: true, class: 'text-center b-table-th-td'},
      ],
      totalCount: 0,
      isAllCheckedDelete: false,
      errors: [],
      progressFloat: 0,
      isShow: false
    });

    /******************************
     * 検索ボタン押下
     ******************************/

    const searchClick = () => {
      state.condition.page = 1;
      search();
    };

    /******************************
     * 検索API
     ******************************/

    const search = async () => {
      
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/teacher/sumup_list?${Common.BuildQuery(state.condition, 'search_condtion')}`).then(response => {
        state.sumupGroups = response.data.sumup_groups.map((x: any) => new SumupGroup(x));
        context.root.$store.commit("setSumupListCondition", state.condition);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 実施日を画面表示文言にコンバート
     ******************************/

    const convertExecDate = (execDate: string) => {
      return execDate ? moment(execDate).format('M月D日') : "-";
    };

    /******************************
     * 採点状態文言にコンバート
     ******************************/

    const convertStatusText = (saitenCompleted: boolean) => {
      return saitenCompleted ? "完了" : "未完了";
    }

    /******************************
     * クリアボタン押下
     ******************************/

    const clearCondition = () => {
      state.condition = new SumupListCondition();
    };

    /******************************
     * ページング
     ******************************/

    const changePage = (page: number) => {
      state.condition.page = page;
      context.root.$store.commit("setSumupListCondition", state.condition);
    };

    /******************************
     * 集計マスタ追加ボタン押下
     ******************************/

    const addSumupGroupClick = () => {
      context.root.$router.push('/teacher_site/sumup_edit/new').catch(err => {});
    };

    /******************************
     * 設定ボタン押下
     ******************************/

    const sumupEditClick = (id: number) => {
      context.root.$router.push(`/teacher_site/sumup_edit/${id}`).catch(err => {});
    };

    /******************************
     * 統計ボタン押下
     ******************************/

    const sumupDetailClick = (id: number) => {
      context.root.$store.commit("setSumupDetailCurriculumId", 0);
      context.root.$router.push(`/teacher_site/sumup_detail_total/${id}`).catch(err => {});
    }

    /******************************
     * 一覧ボタン押下
     ******************************/

    const sumupResultRankClick = (id: number) => {
      context.root.$store.commit("setSumupResultCurriculumId", 0);
      context.root.$router.push(`/teacher_site/sumup_result_rank_list_total/${id}`).catch(err => {});
    }

    /******************************
     * 削除列ヘッダーCheckBoxの監視
     ******************************/

    watch(() => state.isAllCheckedDelete, (newVal, oldVal) => {
      state.sumupGroups.forEach(x => x.isSelected = newVal);
    });


    /******************************
     * 削除アイコン押下
     ******************************/

    const sumupGruoupDelete = async () => {

      state.errors = []

      const ids = state.sumupGroups.filter(x => x.isSelected).map(x => x.id);

      if(ids.length == 0){
        state.errors.push("削除対象が選択されていません。");
      }

      if (!window.confirm('集計マスタを削除します。よろしいですか？')) {
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/sumup_list/sumup_groups_destroy`, {ids: ids}).then(response => {
        alert("処理が完了しました。");
        search();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * mounted キャッシュしている検索条件で検索実行
     ******************************/
    
    onMounted(async () => {
      state.condition = context.root.$store.state.sumupListCondition;
      if(context.root.$store.state.sheetType != Common.SheetTypeEnum.Entrance && context.root.$store.state.sheetType != Common.SheetTypeEnum.EntranceCompare){
        context.root.$store.commit("setSheetType", Common.SheetTypeEnum.Entrance);
      }
      await search();
      state.isShow = true;
    });

    /******************************
     * 採点結果エクセルダウンロード
     ******************************/

    const downloadSaitenResult = async (sumupGroup: SumupGroup) => {
      if(!window.confirm("採点結果Excelファイルを出力します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay", {overlayText: "出力中。処理に数分かかる場合があります。画面を閉じずにそのままお待ちください。途中で画面を閉じると処理が中断されます。", isShowProgress: true});

      for(let i = 0; i < sumupGroup.curriculum_ids.length; i++){

        const curriculum_id = sumupGroup.curriculum_ids[i];

        await http.get(`/api/teacher/sumup_list/saiten_result_data/${sumupGroup.id}/${curriculum_id}`).then(async response => {
          const workbook = new ExcelJS.Workbook();

          const sheets = response.data.sheets;
          const all_examinee_hashes = response.data.all_examinee_hashes;
          const all_sheet_field_hashes = response.data.all_sheet_field_hashes;
          const all_field_activity_hashes = response.data.all_field_activity_hashes;
          const all_sheet_activity_hashes = response.data.all_sheet_activity_hashes;
          const sheet_process_ids = response.data.sheet_process_ids;

          const progressStep = 100 / sumupGroup.curriculum_ids.length / all_examinee_hashes.length;
          let maxProgress = state.progressFloat + (100 / sumupGroup.curriculum_ids.length)
          await createSheetQuestion(workbook, sheets, all_examinee_hashes, all_sheet_field_hashes, all_field_activity_hashes, all_sheet_activity_hashes, sheet_process_ids, progressStep, maxProgress);
          
          state.progressFloat = 100 / sumupGroup.curriculum_ids.length * (i + 1);
          if(state.progressFloat >= 100 || i + 1 == sumupGroup.curriculum_ids.length){
            state.progressFloat = 100;
          }
          context.root.$store.commit("setProgressText", Number.parseFloat(`${state.progressFloat}`).toFixed(2));
          await resolveAfterMilliSeconds();
          
          const uint8Array = await workbook.xlsx.writeBuffer();
          const blob = new Blob([uint8Array], { type: "application/octet-binary" });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `${sheets[0].name}_${context.root.$store.getters.getCurriculumNameById(curriculum_id)}.xlsx`;
          a.click();
          a.remove();
        })
        .catch(error=>{
          if(error.response.status == 422){
            const errorData = JSON.parse((new TextDecoder).decode(new Uint8Array(error.response.data)));
            state.errors = errorData.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });

        // エラーありの場合は処理終了
        if(state.errors.length > 0){
          context.root.$store.dispatch("hideOverlay");
          return;
        }
      }

      await resolveAfterMilliSeconds();

      alert("処理が完了しました。");
      context.root.$store.dispatch("hideOverlay");
    }

    const resolveAfterMilliSeconds = () => {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve('resolved');
        }, 1);
      });
    }

    /******************************
     * 設問別シート作成
     ******************************/

    const createSheetQuestion = async (workbook: ExcelJS.Workbook, sheets: any[], all_examinee_hashes: any[], all_sheet_field_hashes: any[], all_field_activity_hashes: any[], all_sheet_activity_hashes: any[], sheet_process_ids: number[], progressStep: number, maxProgress: number) => {

      const sheet = sheets[0]

      /******************************
       * 設問別シートのヘッダ作成
       ******************************/
      workbook.addWorksheet("設問別");
      const q_worksheet = workbook.getWorksheet("設問別");
      
      let header = `${sheet.name}　${context.root.$store.getters.getCurriculumNameById(sheet.curriculum_id)}　${sheet.subject_name}`;
      q_worksheet.getRow(1).getCell(1).value = header;
      q_worksheet.getRow(2).getCell(4).value = '合計';
      q_worksheet.getRow(5).getCell(1).value = '教室';
      q_worksheet.getRow(5).getCell(2).value = '受験番号';
      q_worksheet.getRow(5).getCell(3).value = '氏名';

      // 試験全体の配点・平均点・得点率生成
      // 配点
      q_worksheet.getCell(3, 4).value = sheet.allot;

      // 平均点
      let sum_total_score = Common.sumArray(all_sheet_activity_hashes.map((sa: any) => sa.score));
      let attend_examinees_count = all_examinee_hashes.filter((x: any) => !x["absent_flg"]).length;
      q_worksheet.getCell(4, 4).value = `${(sum_total_score / attend_examinees_count).toFixed(1)}点`;

      // 得点率
      let sheet_total_allot = sheet.allot * attend_examinees_count
      q_worksheet.getCell(5, 4).value = `${((sum_total_score / sheet_total_allot) * 100).toFixed()}%`

      let sheet_field_count = 0;

      const rowNos = [...new Set(all_sheet_field_hashes.map((x: any) => x["row_no"]))]

      for(let i = 0; i < rowNos.length; i++){
        const rowNo = rowNos[i]

        const sf_group = all_sheet_field_hashes.filter((x: any) => x["row_no"] == rowNo);
        const sf = sf_group[0];
        let col_idx = i + 5;

        // 設問名
        q_worksheet.getCell(2, col_idx).value = sf["question"];

        // 配点
        q_worksheet.getCell(3, col_idx).value = sf["allot"];

        //　平均点
        const sheet_field_ids = sf_group.map((x: any) => x["id"]);
        const field_activity_hashes = all_field_activity_hashes.filter((x: any) => sheet_field_ids.includes(x["sheet_field_id"]));
        const sum_field_score = Common.sumArray(field_activity_hashes.map((fa: any) => fa["score"]));
        q_worksheet.getCell(4, col_idx).value = `${(sum_field_score / field_activity_hashes.length).toFixed(1)}点`

        // 得点率
        const field_total_allot = sf["allot"] * field_activity_hashes.length
        if(field_total_allot == 0){
          q_worksheet.getCell(5, col_idx).value = 0;
        }else{
          q_worksheet.getCell(5, col_idx).value = `${((sum_field_score / field_total_allot) * 100).toFixed()}%`;
        }

        sheet_field_count += 1;
      }

      /******************************
       * 大問別シートのヘッダ作成
       ******************************/
      workbook.addWorksheet("大問別");
      const p_worksheet = workbook.getWorksheet("大問別");

      header = `${sheet.name}　${context.root.$store.getters.getCurriculumNameById(sheet.curriculum_id)}　${sheet.subject_name}`;
      p_worksheet.getRow(1).getCell(1).value = header;
      p_worksheet.getRow(2).getCell(4).value = '合計';
      p_worksheet.getRow(5).getCell(1).value = '教室';
      p_worksheet.getRow(5).getCell(2).value = '受験番号';
      p_worksheet.getRow(5).getCell(3).value = '氏名';
    
      // 配点
      p_worksheet.getCell(3, 4).value = sheet.allot;

      // 平均点
      sum_total_score = Common.sumArray(all_sheet_activity_hashes.map((sa: any) => sa["score"]));
      attend_examinees_count = all_examinee_hashes.filter((x: any) => !x["absent_flg"]).length;
      p_worksheet.getCell(4, 4).value = `${(sum_total_score / attend_examinees_count).toFixed(1)}点`;

      // 得点率
      sheet_total_allot = sheet.allot * attend_examinees_count
      p_worksheet.getCell(5, 4).value = `${((sum_total_score / sheet_total_allot) * 100).toFixed(0)}%`

      // 大問No抽出
      const part1s = [...new Set(all_sheet_field_hashes.map((sf: any) => sf["part1"]))].sort((a, b) => a - b);

      part1s.forEach(async (part1: number, i: number) => {
        let col_idx = i + 5

        // 大問Noに紐づくsheet_field取得
        const part1_sheet_field_hashes = all_sheet_field_hashes.filter((x: any) => x["part1"] == part1).sort((a, b) => a["id"] - b["id"]);

        // 大問名
        p_worksheet.getCell(2, col_idx).value = part1;

        // 配点
        const part1_allot = Common.sumArray(part1_sheet_field_hashes.filter((x: any) => x["sheet_id"] == sheets[0]["id"]).map((x: any) => x["allot"]));
        p_worksheet.getCell(3, col_idx).value = part1_allot;

        // 平均点
        const field_activity_hashes = all_field_activity_hashes.filter((fa: any) => part1_sheet_field_hashes.map((x: any) => x["id"]).includes(fa["sheet_field_id"]));
        const sum_field_score = Common.sumArray(field_activity_hashes.map((fa: any) => fa["score"]));
        p_worksheet.getCell(4, col_idx).value = `${(sum_field_score / attend_examinees_count).toFixed(1)}点`;

        // 得点率
        const field_total_allot = part1_allot * attend_examinees_count;
        if(field_total_allot == 0){
          p_worksheet.getCell(5, col_idx).value = 0;
        }else{
          p_worksheet.getCell(5, col_idx).value = `${((sum_field_score / field_total_allot) * 100).toFixed(0)}%`;
        }
      });

      /******************************
       * 観点別シートのヘッダ作成
       ******************************/
      workbook.addWorksheet("観点別");
      const v_worksheet = workbook.getWorksheet("観点別");

      header = `${sheet.name}　${context.root.$store.getters.getCurriculumNameById(sheet.curriculum_id)}　${sheet.subject_name}`;
      v_worksheet.getRow(1).getCell(1).value = header;
      v_worksheet.getRow(2).getCell(4).value = '合計';
      v_worksheet.getRow(5).getCell(1).value = '教室';
      v_worksheet.getRow(5).getCell(2).value = '受験番号';
      v_worksheet.getRow(5).getCell(3).value = '氏名';
    
      // 配点
      v_worksheet.getCell(3, 4).value = sheet.allot;

      // 平均点
      sum_total_score = Common.sumArray(all_sheet_activity_hashes.map((sa: any) => sa["score"]));
      attend_examinees_count = all_examinee_hashes.filter((x: any) => !x["absent_flg"]).length;
      v_worksheet.getCell(4, 4).value = `${(sum_total_score / attend_examinees_count).toFixed(1)}点`;

      // 得点率
      sheet_total_allot = sheet.allot * attend_examinees_count
      v_worksheet.getCell(5, 4).value = `${((sum_total_score / sheet_total_allot) * 100).toFixed(0)}%`

      // 観点No抽出
      const view_point_ids = [...new Set(all_sheet_field_hashes.filter((sf: any) => sf["view_point_id"] != null).map((sf: any) => sf["view_point_id"]))].sort((a, b) => a - b);

      view_point_ids.forEach(async (view_point_id: number, i: number) => {
        let col_idx = i + 5

        // 観点Noに紐づくsheet_field取得
        const view_point_id_sheet_field_hashes = all_sheet_field_hashes.filter((x: any) => x["view_point_id"] == view_point_id).sort((a, b) => a["id"] - b["id"]);

        // 観点名
        v_worksheet.getCell(2, col_idx).value = context.root.$store.getters.getViewPointNameById(view_point_id);

        // 配点
        const view_point_id_allot = Common.sumArray(view_point_id_sheet_field_hashes.filter((x: any) => x["sheet_id"] == sheets[0]["id"]).map((x: any) => x["allot"]));
        v_worksheet.getCell(3, col_idx).value = view_point_id_allot;

        // 平均点
        const field_activity_hashes = all_field_activity_hashes.filter((fa: any) => view_point_id_sheet_field_hashes.map((x: any) => x["id"]).includes(fa["sheet_field_id"]));
        const sum_field_score = Common.sumArray(field_activity_hashes.map((fa: any) => fa["score"]));
        v_worksheet.getCell(4, col_idx).value = `${(sum_field_score / attend_examinees_count).toFixed(1)}点`;

        // 得点率
        const field_total_allot = view_point_id_allot * attend_examinees_count;
        if(field_total_allot == 0){
          v_worksheet.getCell(5, col_idx).value = 0;
        }else{
          v_worksheet.getCell(5, col_idx).value = `${((sum_field_score / field_total_allot) * 100).toFixed(0)}%`;
        }
      });

      let row_idx = 6;

      for(let sheet_idx = 0; sheet_idx < sheets.length; sheet_idx++){
        const sheet = sheets[sheet_idx];
        
        const examinees = all_examinee_hashes.filter((x: any) => x["sheet_id"] == sheet["id"]).sort((a, b) => a["student_no"] - b["student_no"]);
        for(let e of examinees){

          const q_row = []
          const p_row = []
          const v_row = []

          q_row.push(sheet.room_name);
          q_row.push(e.student_no_character);
          q_row.push(e.student_name);
          p_row.push(sheet.room_name);
          p_row.push(e.student_no_character);
          p_row.push(e.student_name);
          v_row.push(sheet.room_name);
          v_row.push(e.student_no_character);
          v_row.push(e.student_name);
          
          if(e.absent_flg){
            // 欠席生徒の場合 合計点に０、設問別得点にハイフンを設定
            q_row.push("-");
            for(let j = 0; j < sheet_field_count; j++){
              q_row.push("-");
            }

            // 欠席生徒の場合 合計点に０、設問別得点にハイフンを設定
            p_row.push("-");
            part1s.forEach(() => {
              p_row.push("-");
            });

            // 欠席生徒の場合 合計点に０、設問別得点にハイフンを設定
            v_row.push("-");
            view_point_ids.forEach(() => {
              v_row.push("-");
            });

          }else{
            // 合計点
            const sheet_activity_hashes = all_sheet_activity_hashes.filter((sa: any) => sa["student_id"] == e.student_no && sa["sheet_process_id"] == sheet_process_ids[sheet_idx])
            const total_score = Common.sumArray(sheet_activity_hashes.map((sa: any) => sa["score"]))
            q_row.push(total_score);
            p_row.push(total_score);
            v_row.push(total_score);

            const part1Scores: any[] = part1s.map((part1: number) => {
              return {part1: part1, score: 0}
            });

            const viewPointScores: any[] = view_point_ids.map((view_point_id: number) => {
              return {view_point_id: view_point_id, score: 0}
            });

            // 設問別得点
            const sheet_activity_ids = sheet_activity_hashes.map((sa: any) => sa["id"]);
            const field_activity_hashes = all_field_activity_hashes.filter((fa: any) => sheet_activity_ids.includes(fa["sheet_activity_id"])).sort((a, b) => a["sheet_field_id"] - b["sheet_field_id"]);
            field_activity_hashes.forEach((fa: any, j: number) => {
              if(fa["score"]){
                q_row.push(fa["score"])

                const part1 = all_sheet_field_hashes.filter((sf: any) => sf.id == fa.sheet_field_id)[0].part1;
                const part1Score = part1Scores.filter((part1Score: any) => part1Score.part1 == part1)[0];
                part1Score.score += fa["score"];

                const view_point_id = all_sheet_field_hashes.filter((sf: any) => sf.id == fa.sheet_field_id)[0].view_point_id;
                if(view_point_id != null){
                  const viewPointScore = viewPointScores.filter((viewPointScore: any) => viewPointScore.view_point_id == view_point_id)[0];
                  viewPointScore.score += fa["score"];
                }
              }else{
                q_row.push(0);
              }
            });

            part1Scores.forEach((part1Score: any) => {
              p_row.push(part1Score.score);
            });

            viewPointScores.forEach((viewPointScore: any) => {
              v_row.push(viewPointScore.score);
            });
          }
          q_worksheet.insertRow(row_idx, q_row);
          p_worksheet.insertRow(row_idx, p_row);
          v_worksheet.insertRow(row_idx, v_row);

          row_idx += 1

          if(state.progressFloat + progressStep >= maxProgress){
            state.progressFloat = maxProgress;
          }else{
            state.progressFloat += progressStep;
          }
          context.root.$store.commit("setProgressText", Number.parseFloat(`${state.progressFloat}`).toFixed(2));
          Number.parseFloat(`${state.progressFloat}`).toFixed(2)
          await resolveAfterMilliSeconds();
        }
      }

      if(view_point_ids.length == 0){
        workbook.removeWorksheet("観点別");
      }
    }

    return {
      ...toRefs(state),
      search,
      searchClick,
      convertExecDate,
      convertStatusText,
      clearCondition,
      changePage,
      addSumupGroupClick,
      sumupEditClick,
      sumupGruoupDelete,
      sumupResultRankClick,
      sumupDetailClick,
      downloadSaitenResult,
    }
  }
});
